module.exports = __webpack_public_path__ + "img/arrow.9bbe8ac3.svg";